<template>
	<v-sheet style="min-height:100%" class="d-flex align-start justify-center">
		<v-container>
		  <router-view ref="component">
		  	<!-- Componente asociado a ruta -->
		  </router-view>
			<check-version
				@entendido="onAceptarAdvertenciaVersion"
			/>
		</v-container>
		<v-footer absolute padless>
			<v-sheet class="pa-2 text-center text-subtitle-1 white--text" color="primary" width="100%">
				e-Boleta
			</v-sheet>
			<v-sheet class="pa-1" color="warning" width="100%"/>
		</v-footer>
	</v-sheet>
</template>
<script>

import CheckVersion from '@/components/CheckVersion';



export default {
	components: {
		CheckVersion
	},
	methods:{
		onAceptarAdvertenciaVersion(){
			let component = this.$refs.component;
			component.iniciarSesion(true);
		}
	}
}
</script>